const limitRemovedNames = [
    'Terter.4125',
    'Jen.6021',
];

export default limitRemovedNames;